class DaySingleSelectController {
  constructor(dayService) {
    this.dayService = dayService;
  }

  $onInit(){
    this.dayService.findAll(-1).then(result => {
        this.day = result;
        this.day.unshift({id: '', name: 'None', category: 'Select no Spa Day'});
    });
  }
}

DaySingleSelectController.$inject = [ 'dayService' ];

export default DaySingleSelectController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/controllers/day.single.select.controller.js